import FormUserView from 'User/Application/Views/FormUserView';
import TableUserView from 'User/Application/Views/TableUserView';
import FormProposalProjectView from 'ProposalProject/ProposalProject/Application/Views/FormProposalProjectView';
import AdminNewsView from 'UI/Application/Views/AdminNewsView';
import AdminCorporateDocumentsView from 'CorporateDocument/Application/Views/AdminCorporateDocumentsView';
import AdminReportsView from 'UI/Application/Views/AdminReportsView';
import { PRIVATE_ADMIN_FORM_USER, PRIVATE_ADMIN_LIST_USERS } from '../Constants/PathsConstant';
import { ADMIN_PROPOSAL_PROJECT_FORM } from 'ProposalProject/ProposalProject/Application/Constants/PathsConstant';
import { PRIVATE_ADMIN_NEWS, PRIVATE_ADMIN_DOCUMENTS, PRIVATE_ADMIN_REPORTS } from 'Shared/Routing/Application/Constants/PathsConstant';

export const AdminRouter = [
  {
    path: PRIVATE_ADMIN_LIST_USERS,
    element: <TableUserView />,
    children: []
  },
  {
    path: PRIVATE_ADMIN_FORM_USER + '/:id',
    element: <FormUserView />,
    children: []
  },
  {
    path: ADMIN_PROPOSAL_PROJECT_FORM + '/:id',
    element: <FormProposalProjectView />,
    children: []
  },
  {
    path: PRIVATE_ADMIN_NEWS,
    element: <AdminNewsView />,
    children: []
  },
  {
    path: PRIVATE_ADMIN_DOCUMENTS,
    element: <AdminCorporateDocumentsView />,
    children: []
  },
  {
    path: PRIVATE_ADMIN_REPORTS,
    element: <AdminReportsView />,
    children: []
  }
];